<template>
    <div class="main-wrap">
        <template v-if="userIsAuth == 'p' || userIsAuth == 'n' || userIsAuth == 'y'">
            <div class="item">
                <div class="label">业务负责人</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.companyKeyPerson">{{userInfo.companyKeyPerson}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="companyKeyPerson">
                            <el-form-item
                                prop="companyKeyPerson"
                                :rules="[
                                    { required: true, message: '请输入业务负责人姓名'},
                                ]"
                            >
                                <el-input v-model="brandForm.companyKeyPerson" size="small"
                                    placeholder="请输入业务负责人姓名"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('companyKeyPerson')">保存</el-button>
                                <el-button size="small" @click="editBrand.companyKeyPerson = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('companyKeyPerson')"></i> -->
                </div>
            </div>
            <div class="item">
                <div class="label">业务负责人电话</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.companyKeyPersonPhone">{{userInfo.companyKeyPersonPhone}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="companyKeyPersonPhone">
                            <el-form-item
                                prop="companyKeyPersonPhone"
                                :rules="[
                                    { required: true, message: '请输入业务负责人电话'},
                                ]"
                            >
                                <el-input v-model="brandForm.companyKeyPersonPhone" size="small"
                                    placeholder="请输入业务负责人电话"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('companyKeyPersonPhone')">保存</el-button>
                                <el-button size="small" @click="editBrand.companyKeyPersonPhone = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('companyKeyPersonPhone')"></i> -->
                </div>
            </div>
            <div class="item">
                <div class="label">公司电话</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.companyPhone">{{userInfo.companyPhone}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="companyPhone">
                            <el-form-item
                                prop="companyPhone"
                                :rules="[
                                    { required: true, message: '请输入公司电话'},
                                ]"
                            >
                                <el-input v-model="brandForm.companyPhone" size="small"
                                    placeholder="请输入公司电话"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('companyPhone')">保存</el-button>
                                <el-button size="small" @click="editBrand.companyPhone = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('companyPhone')"></i> -->
                </div>
            </div>
            <div class="item">
                <div class="label">公司地址</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.address">{{userInfo.addressStr}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="address">
                            <el-form-item prop="addressArea" size="small" required
                                :rules="[
                                    { validator: validAddressArea},
                                ]"
                            >
                                <area-picker type="edit" :data.sync="brandForm.addressArea" />
                            </el-form-item>
                            <el-form-item prop="addressString" size="small"
                                :rules="[
                                    { required: true, message: '请输入详细地址'},
                                ]"
                            >
                                <el-input type="textarea" v-model.trim="brandForm.addressString"
                                    placeholder="请输入详细地址"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('address')">保存</el-button>
                                <el-button size="small" @click="editBrand.address = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('address')"></i> -->
                </div>
            </div>
        </template>
        <div class="item">
            <div class="label">主营品类</div>
            <div class="content">
                <div class="cate-text">
                    <template  v-for="(item, index) in userInfo.mainTypeLists" >
                        <div class="cate-line" :key="item.dataName + index" v-if="item.checked">
                            <p class="cate-lab">{{item.dataName}}</p> 
                            <p class="cate-con">
                                <template v-for="(ele, i) in item.list">
                                    <span :key="ele.name + i" v-if="ele.checked">{{ele.name}}</span>
                                    
                                </template>
                            </p>
                        </div>
                    </template>
                </div>
            </div>
            <div class="btn-wrap">
                <!-- <el-button type="primary" size="small" @click="editBrandHandle('clothesData')">编辑品类</el-button> -->
                <i class="icon-edit" @click="editBrandHandle('clothesData')"></i>
            </div>
        </div>
        <div class="item">
            <div class="label">主要销售渠道</div>
            <div class="content">
                <div class="text" v-if="!editBrand.channel">{{userInfo.channelStr}}</div>
                <div class="edit-box" v-else>
                    <el-form :model="brandForm" ref="channel">
                        <el-form-item
                            prop="channel"
                            :rules="[
                                { validator: validateChannel},
                            ]"
                        >
                            <el-checkbox 
                                :label="item.dataName"
                                :checked="item.isSelect == 1"
                                v-for="(item,index) in brandForm.channel.list" :key="item.dataName + index"
                                @change="(e) => selectChannel(e, item) "
                            ></el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitBrandForm2('channel')">保存</el-button>
                            <el-button size="small" @click="editBrand.channel = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editBrandHandle('channel')"></i>
            </div>
        </div>
        <div class="item" v-if="userIsAuth == 'y'">
            <div class="label">我的品牌</div>
            <div class="content">
                <div class="text" v-if="!editBrand.brandList">
                    <el-tag
                        style="margin-bottom: 8px;"
                        :key="tag+i"
                        v-for="(tag, i) in brandForm.brandList"
                    >
                    {{tag}}
                </el-tag>
                </div>
                <div class="edit-box" v-else>
                    <el-form :model="brandForm" ref="brandList">
                        <el-form-item prop="brandList"
                            :rules="[
                                { validator: validateBrandList},
                            ]"
                        >
                            <el-tag
                                :key="tag+i"
                                v-for="(tag, i) in brandForm.brandList"
                                closable
                                :disable-transitions="false"
                                @close="handleTagClose(tag)">
                                {{tag}}
                            </el-tag>
                            <el-input
                                class="input-new-tag"
                                v-if="brandInputVisible"
                                v-model="brandInputValue"
                                ref="saveTagInput"
                                size="small"
                                @keyup.enter.native="handleTagInputConfirm"
                                @blur="handleTagInputConfirm"
                                placeholder="请输入品牌名称"
                            >
                            </el-input>
                            <el-button v-else class="button-new-tag" size="small" @click="showTagInput">+ 品牌</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitBrandForm3('brandList')">保存</el-button>
                            <el-button size="small" @click="editBrand.brandList = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editBrandHandle('brandList')"></i>
            </div>
        </div>

        <el-dialog title="选择主营品类" :visible.sync="editBrand.clothesData" width="900px" class="dialog-header-border">
            <div class="cate-pop">
                <el-form :model="brandForm" ref="clothesData">
                    <el-form-item prop="clothesData"
                        :rules="[
                            { validator: validateClothesData},
                        ]"
                    >
                        <div class="cate-line" v-for="(item, index) in brandForm.clothesData" :key="item.dataName + index">
                            <strong class="cate-lab">{{item.dataName}}</strong>
                            <div class="cate-select w">
                                <el-checkbox :label="ele.name"
                                    v-for="(ele, i) in item.list" :key="ele+i"
                                    v-model="ele.checked"
                                    @change="changeClothesTag"
                                ></el-checkbox>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editBrand.clothesData = false">取 消</el-button>
                <el-button type="primary" @click="submitBrandForm2('clothesData')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import areaPicker from '@/components/areaPicker.vue'

export default {
    components: {
        areaPicker
    },
    data() {
        return {
            // 品牌相关
            myBrandList: [],
            brandInputVisible: false,
            brandInputValue: '',

            editBrand: {
                companyKeyPerson: false,
                companyKeyPersonPhone: false,
                companyPhone: false,
                address: false,
                clothesData: false,
                channel: false,
                brandList: false
            },
            brandForm: {
                companyKeyPerson: '',
                companyKeyPersonPhone: '',
                companyPhone: '',
                addressArea: {
                    regionProvince: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionCity: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionDistrict: {
                        region_name:  '',
                        region_id: ''
                    }
                },
                addressString: '',
                clothesData: [], // 品类
                channel: {},  // 销售渠道
                brandList: []
            },
        }
    },
    computed: {
        ...mapGetters(['userId', 'userIsAuth', 'userInfo'])
    },
    created() {
        this.getBrandData()
    },
    methods: {
        // 打开编辑
        editBrandHandle(keyName) {
            this.editBrand[keyName] = true
            if (keyName === 'companyKeyPerson') {
                this.brandForm.companyKeyPerson = this.userInfo.companyKeyPerson
            }
            if (keyName === 'companyKeyPersonPhone') {
                this.brandForm.companyKeyPersonPhone = this.userInfo.companyKeyPersonPhone
            }
            if (keyName === 'companyPhone') {
                this.brandForm.companyPhone = this.userInfo.companyPhone
            }
            if (keyName === 'address') {
                this.brandForm.addressArea = {
                    regionProvince: {
                        region_name: this.userInfo.companyProvinceStr || '',
                        region_id: this.userInfo.companyProvince || '',
                    },
                    regionCity: {
                        region_name: this.userInfo.companyCityStr || '',
                        region_id: this.userInfo.companyCity || '',
                    },
                    regionDistrict: {
                        region_name: this.userInfo.companyDistrictStr || '',
                        region_id: this.userInfo.companyDistrict || '',
                    }
                }
                this.brandForm.addressString = this.userInfo.factoryAddressStr || ''
            }
            if (keyName === 'clothesData') {
                this.brandForm.clothesData = JSON.parse(JSON.stringify(this.userInfo.mainTypeLists))
                this.editBrand.clothesData = true
            }
            if (keyName === 'channel') {
                this.brandForm.channel = JSON.parse(JSON.stringify(this.userInfo.channel))
                this.editBrand.channel = true
            }
            if (keyName === 'brandList') {
                this.editBrand.brandList = true
                this.brandForm.brandList = [...this.myBrandList]
            }
        },
        // 提交编辑
        submitBrandForm(keyName) {
            this.$refs[keyName].validate((valid) => {
                if (valid) {
                    // console.log('pass')
                    
                    let params = {
                        "userId": this.userId,
                        "companyProvince": this.userInfo.companyProvince,
                        "companyCity": this.userInfo.companyCity,
                        "companyDistrict": this.userInfo.companyDistrict,
                        "companyPhone": this.userInfo.companyPhone,
                        "companyKeyPerson": this.userInfo.companyKeyPerson,
                        "companyKeyPersonPhone": this.userInfo.companyKeyPersonPhone
                    }

                    if (keyName === 'companyKeyPerson') {
                        params.companyKeyPerson = this.brandForm.companyKeyPerson
                    }
                    if (keyName === 'companyKeyPersonPhone') {
                        params.companyKeyPersonPhone = this.brandForm.companyKeyPersonPhone
                    }
                    if (keyName === 'companyPhone') {
                        params.companyPhone = this.brandForm.companyPhone
                    }
                    if (keyName === 'address') {
                        let { addressArea } = this.brandForm
                        params.companyProvince = addressArea.regionProvince.region_id
                        params.companyCity = addressArea.regionCity.region_id
                        params.companyDistrict = addressArea.regionDistrict.region_id
                        params.factoryAddress = this.brandForm.addressString
                    }
                
                    request({
                        url:api.editUserAuth,
                        data: params
                    }).then(res => {
                        // console.log(res)
                        if (res.errorCode == 200) {
                            this.$store.dispatch('getUserInfo')
                            this.editBrand[keyName] = false
                        } else {
                            this.$message.error(res.errorMsg || '编辑失败')
                        }
                    })
                }
            })
        },
        // 提交编辑
        submitBrandForm2(keyName) {
            this.$refs[keyName].validate((valid) => {
                if (valid) {
                    // console.log('pass')
                    
                    let params = {
                        product: this.userInfo.mainTypeLists,
                        channel: this.userInfo.channel
                    }
                    if (keyName === 'clothesData') {
                        params.product = this.brandForm.clothesData
                    }
                    if (keyName === 'channel') {
                        params.channel = this.brandForm.channel
                    }
                    // console.log(params)
                    request({
						url: api.editExtraInfo,
						data: {
							userId: this.userId,
							regStr: JSON.stringify(params)
                        }
                    }).then(res => {
                        if (res.errorCode == 200) {
                            this.$store.dispatch('getUserInfo')
                            this.editBrand[keyName] = false
                        } else {
                            this.$message.error(res.errorMsg || '编辑失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })

                }
            })
        },
        // 提交编辑
        submitBrandForm3(keyName) {
            this.$refs[keyName].validate((valid) => {
                if (valid) {
                    // console.log('pass')
                    let brandListStr = this.brandForm.brandList.join(',')
                    request({
						url: api.updateUserAuthCompanyBand,
						data: {
							userId: this.userId,
						    companyBrand: brandListStr
                        }
                    }).then(res => {
                        if (res.errorCode == 200) {
                            this.getBrandData()
                            this.editBrand[keyName] = false
                        } else {
                            this.$message.error(res.errorMsg || '编辑失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                }
            })
        },
        // 自定义校验函数
        validAddressArea(rule, value, callback) {
            // console.log(value)
            if (!this.brandForm.addressArea.regionCity.region_id) {
                callback(new Error('请选择省市区'))
            } else {
                callback()
            }
        },
        validateClothesData(rule, value, callback) {
            if (this.brandForm.clothesData.some(item => item.checked)) {
                callback()
            } else {
                callback(new Error('请选择您的主营品类'))
            }
        },
        validateChannel(rule, value, callback) {
            if (this.brandForm.channel.list.some(item => item.isSelect == '1')) {
                callback()
            } else {
                callback(new Error('请选择您的主要销售渠道'))
            }
        },
        // 选择主营品类
        changeClothesTag() {
            this.checkClothesData('clothesData', 'clothesData')
        },
        // 主营品类 - 数据调整、校验
        checkClothesData(dataName, validName) {
            this.brandForm[dataName].forEach(item => {
                item.checked = item.list.some(ele => ele.checked)
            })
            this.$refs[dataName].validateField(validName)
        },
        // 选择渠道
        selectChannel(e, item) {
            e ? item.isSelect = '1' : item.isSelect = '0'
            this.$refs['channel'].validateField('channel')
        },

        // 获取品牌
        getBrandData() {
            request({
                url: api.showUserAuthBrand,
                data: {
                    userId: this.userId
                }
            }).then(res => {
                if (res.errorCode === 200) {
                    if (res.data.companyBrand) {
                        this.myBrandList = res.data.companyBrand.split(',')
                        this.brandForm.brandList = res.data.companyBrand.split(',')
                    }
                } else {
                    // this.$message.error(res.errorMsg || '获取品牌失败')
                }
            })
        },
        handleTagClose(tag) {
            this.brandForm.brandList.splice(this.brandForm.brandList.indexOf(tag), 1)
            this.$refs['brandList'].validateField('validateBrandList')
        },
        showTagInput() {
            this.brandInputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleTagInputConfirm() {
            let brandInputValue = this.brandInputValue;
            if (brandInputValue) {
                this.brandForm.brandList.push(brandInputValue);
                this.$refs['brandList'].validateField('validateBrandList')
            }
            this.brandInputVisible = false;
            this.brandInputValue = '';
        },
        validateBrandList(rule, value, callback) {
            if (this.brandForm.brandList.length == 0) {
                callback(new Error('请添加品牌'))
            } else {
                callback()
            }
        }

    }
}
</script>